<template>
  <div>
    <span v-for="(button, i) in buttons" :key="i">
      <v-menu max-width="300px" v-if="button.confirmation">
        <template v-slot:activator="activator">
          <a-action-button-bar-item
            :button="{...button, click: null}"
            :options="options"
            :activator="activator">
          </a-action-button-bar-item>
        </template>
        <v-card>
          <v-card-text class="pb-0">{{ $t('card-text') }}</v-card-text>
          <v-card-actions>
            <v-btn text color="grey">{{ $t('actions.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="button.click(options)" :color="compute(button.color)">{{ compute(button.text) }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <a-action-button-bar-item
        v-else
        :button="button"
        :options="options"
        :activator="{ attrs: null, on: null}">
      </a-action-button-bar-item>
    </span>
  </div>
</template>

<script>
import AActionButtonBarItem from './AActionButtonBarItem'

export default {
  name: 'AActionButtonsBar',
  components: { AActionButtonBarItem },
  props: ['buttons', 'options'],
  data () {
    return {}
  },
  methods: {
    compute (value, defaultValue) {
      if (value === undefined) {
        return defaultValue
      } else if (value instanceof Function) {
        return value(this.options)
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"card-text": "Do you really want to perform this action?"
	},
	"es": {
		"card-text": "¿Está seguro de que desea realizar esta acción?"
	},
	"fr": {
		"card-text": "Souhaitez-vous réellement effectuer cette action ?"
	},
	"it": {
		"card-text": "Vuoi davvero eseguire questa azione?"
	},
	"pt": {
		"card-text": "Tem a certeza de que pretende efetuar esta ação?"
	},
	"pl": {
		"card-text": "Czy na pewno chcesz wykonać tę akcję?"
	}
}
</i18n>
